export enum DashboardPermissions {
    isAllowedSeeDashboardCompany = "dashboard: company"
}
